import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '../section-header/section-header.component';

interface Compliance {
  icon: string;
  label: string;
  description: string;
}

@Component({
  selector: 'app-compliance-section',
  imports: [SectionHeaderComponent],
  templateUrl: './compliance-section.component.html',
  styleUrl: './compliance-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplianceSectionComponent {
  protected readonly compliances: Compliance[] = [
    {
      icon: 'assets/images/compliance/gdpr.svg',
      label: 'GDPR',
      description:
        'Personal data is processed in accordance with GDPR regulations.',
    },
    {
      icon: 'assets/images/compliance/iso-27001.svg',
      label: 'ISO 27001',
      description: 'Our data center partners are ISO 27001-certified.',
    },
    {
      icon: 'assets/images/compliance/soc-2.svg',
      label: 'SOC 2 Type II',
      description: 'The audit report is available on request.',
    },
  ];
}
